import { useSnackbar } from "notistack";

const useNotifications = () => {
  const { enqueueSnackbar } = useSnackbar();
  const pushNotification = ({ variant }) => message => {
    enqueueSnackbar(message, {
      variant,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      }
    });
  };
  return {
    ok: pushNotification({ variant: "success" }),
    ko: pushNotification({ variant: "error" })
  };
};

export default useNotifications;
